import { useSelector } from 'react-redux'

import {
  selectRealEstatesData,
  selectRealEstatesFetched
} from 'redux/selectors/RealEstates'

export const useRealEstatesData = () => {
  return useSelector(selectRealEstatesData)
}

export const useRealEstatesFetched = () => {
  return useSelector(selectRealEstatesFetched)
}
